module.exports = __webpack_public_path__ + "media/components/nearby-points/static/photo-1-f1e9a3aa169e4935bcc28df5d1448565.jpg";